<template>
 <v-sheet>
     <v-row>
         <v-col>
             <v-card elevation="2">
                <v-card-title>
                    Reporte por Fecha
                </v-card-title>
                <hr>
                <v-card-text>
                    <v-select
                    v-model="tiporeporte"
                    :items="tipos"
                    outlined
                    label="Seleccione Tipo"
                    ></v-select>
                    <!--FECHA INICIO-->    
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="fechainicio"
                    label="Fecha inicio"
                    append-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                v-model="fechainicio"
                @input="menu = false"
                locale="es-GT"
                @change="validarfechas"
                ></v-date-picker>
            </v-menu>
            <!--FECHA FIN-->    
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    ref="fechafin"
                    v-model="fechafin"
                    label="Fecha Fin"
                    append-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker
                v-model="fechafin"
                @input="menu2 = false"
                locale="es-GT"
                @change="validarfechas"
                ></v-date-picker>
            </v-menu>
                </v-card-text>
                <v-card-actions class="text-center">
                    
                    <v-btn  color="primary" dark @click="compraVenta"> Generar </v-btn>
                </v-card-actions>
            </v-card>
         </v-col>
         <v-col>
             <v-card elevation="2">
                <v-card-title>
                    Más Reportes
                </v-card-title>
                <v-card-text>
                     <v-btn  color="primary" large dark width="100%" @click="inventario" class="mb-2"> Inventario Productos </v-btn>
                     <v-btn  color="primary" large dark width="100%" @click="stockMinimo" class="mb-2"> Inventario de Mínimos </v-btn>
                </v-card-text>
                <v-card-actions>
                    
                </v-card-actions>
            </v-card>
         </v-col>
     </v-row>
     <v-row>
      <v-col>
      </v-col>
     </v-row>
 </v-sheet>
</template>
<script>
import dayjs from 'dayjs'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    data: () => ({
      tipos:["Ventas","Compras"],  
      menu: false,
      menu2: false,
      menucompras1: false,
      menucompras2: false,
      fechainicio:dayjs().format('YYYY-MM-DD'),
      fechafin:dayjs().format('YYYY-MM-DD'),
      tiporeporte:'Ventas',
      productos:[],
      titulopdf:''
    }),
    created(){
      this.main()
    },
    computed:{
      ...mapGetters(['getAllProductos','getUrlPdf'])
    },
    methods:{
      async main(){
        await this.$store.dispatch('setProductos') 
      },
      validarfechas(){

      },
      async generarPdf(){
        const datos = this.productos.length>0?this.productos:[];
        const titulo = this.titulopdf
        try {
          await axios.post(`${this.getUrlPdf}/productos/`,{datos,titulo})
          window.open( `${this.getUrlPdf}/assets/inventario.pdf`,"blank")
        } catch (error) {
          console.log(error)
        }
      },
      inventario(){
        this.titulopdf = 'Inventario de Productos';
        this.productos=[];
        this.productos = this.getAllProductos;
        this.generarPdf();
      },
      stockMinimo(){
        this.titulopdf ='Reporte de productos con stock bajo'
        this.productos=[]
        this.getAllProductos.forEach(item => {
          if(parseInt(item.stockminimo)>parseInt(item.stockactual) ){
            this.productos.push(item)
          }
        });
        this.generarPdf();
      },
      compraVenta(){
          const tipo = this.tiporeporte.toLowerCase()
          window.open(`/archivos/salesbydate.php?type=${tipo}&d1=${this.fechainicio}&d2=${this.fechafin}`,"blank")
          
      },
      inventarios(tipo){
          window.open(`/archivos/inventarios.php?type=${tipo}`,"blank")
      }

    }
}
</script>